import React from "react";

export function PageHeader({ tag, title, subtitle, right }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        <div className="font-mono text-xs uppercase tracking-[0.25em] text-primary mb-2">// {tag}</div>
        <h1 className="font-mono font-bold tracking-tighter text-3xl md:text-4xl">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-muted-foreground max-w-xl">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function verdictStyle(v) {
  switch (v) {
    case "safe":
      return { color: "text-primary", border: "border-primary/50", bg: "bg-primary/10", label: "SAFE" };
    case "malicious":
    case "critical":
      return { color: "text-destructive", border: "border-destructive/50", bg: "bg-destructive/10", label: "MALICIOUS" };
    default:
      return { color: "text-[#FFD700]", border: "border-[#FFD700]/50", bg: "bg-[#FFD700]/10", label: "SUSPICIOUS" };
  }
}

export function severityStyle(s) {
  switch (s) {
    case "success":
      return "text-primary border-primary/50 bg-primary/10";
    case "critical":
      return "text-destructive border-destructive/50 bg-destructive/10";
    case "warning":
      return "text-[#FFD700] border-[#FFD700]/50 bg-[#FFD700]/10";
    default:
      return "text-muted-foreground border-border bg-secondary";
  }
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString();
}
